import React from 'react';
import { InputGroup, Input, InputGroupAddon } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SearchPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilterModalActive: false,
      isCreateAssociationActive: false
    };
  }

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  render = () => {
    return (
      <div>
        <div className={'d-flex'}>
          <div className={'flex-grow-1'}>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <span className={'input-group-text'}>
                  <FontAwesomeIcon icon={['fas', 'search']} />
                </span>
              </InputGroupAddon>
              <Input
                placeholder={this.props.searchPlaceholder}
                value={this.props.searchValue}
                onChange={e => this.props.onSearchChange(e.currentTarget.value)}
                className={'input-search'}
              />
            </InputGroup>
          </div>
          {this.props.children !== undefined && (
            <div className={'text-right pl-3'}>{this.props.children}</div>
          )}
        </div>
      </div>
    );
  };
}
